import { render, staticRenderFns } from "./dialogueM5.vue?vue&type=template&id=88463c34&"
import script from "./dialogueM5.vue?vue&type=script&lang=js&"
export * from "./dialogueM5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports